import { useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import CustomToolbar from './CustomToolbar';
import DragDropRow from './Content/DragDropRow';
import BlockDialog from './Content/BlockDialog';
import BlogCategory from './Category/BlogCategory';
import QuillEditDialog from './Content/QuillEditDialog';
import BasicDateTimePicker from './Content/BlogDatePicker';

import { uiLoading2 } from '../../../actions/ui';
import { basicMsg, htmlMsg } from '../../../actions/swal_msg';
import { generateURL } from '../../../helpers/admin/productHelper';
import { saveBlogDB, uploadBlogContentImages } from '../../../actions/admin/blog';

import { blogFormValidator } from '../../../validators/Blog/BlogSaveValidator';

//Quill
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

//MUI
import {
    Box, Container, TextField, Typography, Button, Stack, Fab, Grid,
    Backdrop, CircularProgress, IconButton, Divider, Dialog, DialogContent
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';

import {
    BLOG_INIT, BLOG_ROW_DEFAULT, DEFAULT_BLOG_COVER,
    BLOG_VIDEO_COVER, CLOUD_BLOG_COVER, formats, modules
} from '../../../constants/admin/blog_constants';
import { GOOGLE_DRIVE_CDN } from '../../../constants/constants';

const VALID_FORMATS = ['image/jpeg', 'image/png', 'image/webp', 'video/mp4', 'video/webm', 'video/ogg', 'video/quicktime'];

const AddBlog = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading2 } = useSelector(state => state.ui);
    const { blog: { categories } } = useSelector(state => state.blog);

    const [loading, setLoading] = useState(false);

    // texto de Quill
    const [text, setText] = useState('');
    // contenido en filas/columnas
    const [row, setRow] = useState(BLOG_ROW_DEFAULT);
    // mostrar diálogo de edición de bloque
    const [open, setOpen] = useState(false);
    // mostrar diálogo de longitud de bloque
    const [open1, setOpen1] = useState(false);

    // contador de filas y columnas (para asignar id's)
    const [rowCounter, setRowCounter] = useState(2);
    const [colCounter, setColCounter] = useState(0);

    const [mainImg, setMainImg] = useState(DEFAULT_BLOG_COVER);
    const { imgSrc, imgFile } = mainImg;

    const imgInputRef = useRef();
    const fileInputRef = useRef();
    
    // información de blog
    const [values, setValues] = useState(BLOG_INIT);
    const { title, author } = values;

    // cambios en Quill Editor
    const handleChange = (html) => {
        if (html === '<p><br></p>')
            setText('');
        else
            setText(html);
    };

    // cambios en campos
    const handleOnChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'title') {
            if (value.length <= 200)
                setValues({ ...values, [name]: value });
        } else if (name === 'author') {
            if (value.length <= 100)
                setValues({ ...values, [name]: value });
        }
    };

    // guardar bloque
    const addBlock = () => {
        if (text !== '') {
            setOpen1(true);
        } else basicMsg('Ingrese contenido en el recuadro');
    };

    // seleccionar longitud de bloque y guardar
    const insertBlock = (xs, md, row_pos) => () => {
        if (row.length > 0) {
            const NewBlock = {
                item: text,
                src: '',
                file: '',
                type: 'txt',
                xs, md, // vista en navegador (Grid)
                // id debe ser un string por el Draggable
                id: `col-${colCounter}`
            };
            setRow(e_row => {
                return e_row.map((e_col, index) => {
                    if (index === row_pos)
                        return {
                            ...e_col,
                            col: [...e_col.col, NewBlock] 
                        };
                    return e_col;
                });
            });
            setColCounter(colCounter + 1);
            setOpen1(false);
            // limpiar campo de Quill
            setText('');
        }
    };

    // limpiar contenido de Quill
    const cleanBlock = () => {
        if (text !== '')
            Swal.fire({
                title: 'Limpiar el contenido del bloque',
                showDenyButton: true,
                confirmButtonText: 'Si',
                denyButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed)
                    setText('');
            });
    };

    // agregar fila de contenido
    const addRow = () => {
        setRow([...row, { col: [], id: `row-${rowCounter}` }]);
        setRowCounter(rowCounter + 1);
    };

    // agregar bloques de archivos a fila
    const uploadFiles = async ({ target }) => {
        setLoading(true);
        const { columns, counter, invalidFiles } = await loadFiles(target.files);
        setRow(e => e.map((u, i) =>
            i === e.length - 1 ? ({ ...u, col: [...u.col, ...columns] }) : u
        ));
        setColCounter(counter);
        fileInputRef.current.value = '';
        setLoading(false);
        if (invalidFiles.length > 0)
            htmlMsg(
                'warning', 'Formatos no compatibles',
                `<div style="text-align: left; padding-left: 0pt;"><ul>${invalidFiles.join('')}</ul></div>`
            );
    };

    // cargar archivos mediante Promesa
    const loadFiles = async (files) => {
        let counter = colCounter;
        // formatos no aceptados
        const invalidFiles = [...files].filter(file =>
            !VALID_FORMATS.includes(file.type)
        ).map(file => `<li>${file.name} (${file.type})</li>`);
        // filtrar archivos válidos
        const validFiles = [...files].filter(file =>
            VALID_FORMATS.includes(file.type)
        );

        // recorre archivos seleccionados y crea los bloques
        const filePromise = validFiles.map(file => new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const src = event.target.result;
                let item = '';

                if (['image/jpeg', 'image/png', 'image/webp'].includes(file.type))
                    item = `<img class="img-fluid" src="${src}" alt="imagen-blog-Nefropolis"/>`;
                else if (['video/mp4', 'video/webm', 'video/ogg', 'video/quicktime'].includes(file.type))
                    item = `<div><h6>Video: ${file.name}</h6><img style="max-width: 100%; height: auto; display: block; margin: auto;" src=${BLOG_VIDEO_COVER} alt="video-blog-Nefropolis"/></div>`;
                

                resolve({
                    item, src, file,
                    type: file.type.startsWith('image') ? 'img' : 'video',
                    xs: 12, md: 6, id: `col-${counter++}`
                });
            };
        }));

        return {
            columns: await Promise.all(filePromise),
            counter, invalidFiles
        };
    };

    // subir portada de Blog
    const uploadMainImg = ({ target }) => {
        const file = target.files[0]
        if (['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async (event) => {
                const src = event.target.result;
                setMainImg({
                    ...mainImg,
                    imgSrc: src,
                    imgFile: file
                });
            };
        }
    };

    // borrar imagen de portada
    const deleteFile = () => {
        setMainImg(DEFAULT_BLOG_COVER)
        imgInputRef.current.value = '';
    };

    // guardar blog en BD
    const saveBlog = () => {
        const SelectedCategories = categories.filter(e => e.checked).map(u => u.category);
        if (blogFormValidator({ ...values, categories: SelectedCategories, imgFile, row })) {
            Swal.fire({
                title: '¿Guardar el blog?',
                showDenyButton: true,
                confirmButtonText: 'Si',
                denyButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    dispatch(uiLoading2(true));

                    let filesCount = 1; // +1 por imagen de portada

                    const data = new FormData();
                    data.append('title', title);
                    data.append('file', imgFile);
                    // quitamos las filas sin contenido
                    const rowContent = row.filter(e => e.col.length > 0);
                    for (const e of rowContent) {
                        for (const col of e.col) {
                            if (col.type === 'img' || col.type === 'video') {
                                data.append('file', col.file);
                                filesCount++;
                            }
                        };
                    };
                    // subida de imágenes a Drive
                    const req = await uploadBlogContentImages(data, 'upload');
                    if (req.status) {
                        const { folderId, imagesId, html } = req.resp;

                        const url = generateURL(title);

                        let i = 0; // contador de filas
                        let content = []; // contenido dinámico hacia BD

                        if (filesCount === imagesId.length) {
                            let j = 0; // contador de archivos
                            // arreglo de id's de archivos
                            const images = imagesId.length > 1 ? imagesId.filter((e, i) => i !== 0) : [];
                            for (const e of rowContent) {
                                content = [...content, {
                                    col: []
                                }];
                                for (const col of e.col) {
                                    const { item, type, xs, md } = col;
                                    if (col.type === 'img') {
                                        content[i].col = [...content[i].col, {
                                            item: `<img class="img-fluid" src="${GOOGLE_DRIVE_CDN}${images[j]}" alt="imagen-blog-Nefropolis">`,
                                            type, xs, md,
                                            fileId: images[j]
                                        }];
                                        j++;
                                    } else if (col.type === 'video') {
                                        content[i].col = [...content[i].col, {
                                            item: `<iframe src="https://drive.google.com/file/d/${images[j]}/preview" title="video-blog-Nefropolis" width="100%" height="100%"></iframe>`,
                                            type, xs, md,
                                            fileId: images[j]
                                        }];
                                        j++;
                                    } else {
                                        content[i].col = [...content[i].col, {
                                            item, type, xs, md,
                                            fileId: ''
                                        }];
                                    }
                                }
                                i++;
                            }
                            dispatch(saveBlogDB({
                                ...values,
                                url,
                                category: SelectedCategories,
                                content,
                                folderId,
                                imgId: imagesId[0],
                                imgUploaded: true
                            }, html, navigate));
                        } else { // no se subieron con éxito todos los archivos
                            for (const e of rowContent) {
                                content = [...content, {
                                    col: []
                                }];
                                for (const col of e.col) {
                                    const { item, type, xs, md } = col;
                                    if (col.type !== 'img' && col.type !== 'video')
                                        content[i].col = [...content[i].col, {
                                            item, type, xs, md,
                                            fileId: ''
                                        }];
                                };
                                i++;
                            }
                            dispatch(saveBlogDB({
                                ...values,
                                url,
                                category: SelectedCategories,
                                content,
                                folderId,
                                imgId: CLOUD_BLOG_COVER,
                                imgUploaded: false
                            }, html, navigate));
                        }
                    } else
                        dispatch(uiLoading2(false));
                }
            });
        }
    };

    return (
        <Container maxWidth="xl" sx={{ mb: 5, mt: '90px' }}>
            <Dialog
                open={loading}
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        p: 3,
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minWidth: 250
                    }
                }}
                hideBackdrop
            >
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <CircularProgress size={48} sx={{ mb: 2 }} />
                    <Typography variant="body1">Subiendo</Typography>
                </DialogContent>
            </Dialog>

            <Box display='flex' justifyContent='flex-start' gap='12px' flexWrap='wrap' mb={2}>
                <IconButton aria-label="go-back" sx={{ my: 'auto' }}
                    onClick={() => navigate('/nefro-admin/blog')}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant='h5' paragraph sx={{ my: 'auto' }}>
                    Agregar nuevo blog
                </Typography>
            </Box>

            <Grid container spacing={4}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Box sx={{ p: 2 }}>
                        <Typography variant='h6' paragraph sx={{ fontWeight: '600' }}>Información del blog</Typography>
                        <TextField fullWidth
                            variant='outlined'
                            label="Título del blog"
                            size='small'
                            name='title'
                            inputProps={{ maxLength: 200 }}
                            value={title}
                            onChange={handleOnChange}
                        />
                        <TextField fullWidth
                            variant='outlined'
                            label="Autor del blog"
                            size='small'
                            name='author'
                            inputProps={{ maxLength: 100 }}
                            value={author}
                            onChange={handleOnChange}
                            sx={{ my: 2 }}
                        />
                        <BasicDateTimePicker
                            fullWidth
                            values={values}
                            setValues={setValues}
                        />
                        <Divider textAlign="left" sx={{ my: 2.5, fontWeight: '600' }}>
                            CATEGORIAS
                        </Divider>
                        <BlogCategory />
                    </Box>
                </Grid>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Box sx={{ p: 2, boxShadow: '0 2px 4px 2px rgb(0 0 0 / 20%)' }}>
                        <Typography variant='h6' paragraph sx={{ fontWeight: '600' }}>Imagen de portada</Typography>
                        <Box sx={{ textAlign: 'center', mb: 3 }}>
                            <Box sx={{ mb: 2 }}>
                                <img src={imgSrc} alt='portada-blog' width='300' height='300' style={{ objectFit: 'contain', borderRadius: '4px' }} />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
                                <Button variant="contained" startIcon={<InsertPhotoIcon />}
                                    component="label">
                                    <input hidden accept="image/*" ref={imgInputRef}
                                        type="file" onChange={uploadMainImg}
                                    />
                                    Imagen de portada
                                </Button>
                                {
                                    (mainImg !== '' && mainImg !== DEFAULT_BLOG_COVER) &&
                                        <IconButton onClick={deleteFile} sx={{ color: '#ec7063' }}><DeleteIcon /></IconButton>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            
            <Box sx={{ mt: 3 }}>
                <CustomToolbar />
                <ReactQuill
                    value={text}
                    name='quill'
                    onChange={handleChange}
                    modules={modules}
                    formats={formats}
                />
            </Box>

            <Stack direction="row" spacing={2} sx={{ mt: 2, mb: 5 }}>
                <Button variant="contained"
                    onClick={addBlock}>
                    Guardar
                </Button>
                <Button onClick={cleanBlock}>
                    Limpiar
                </Button>
                <Button variant="outlined" startIcon={<InsertPhotoIcon />} component="label">
                    <input hidden accept="image/*, video/*"
                        ref={fileInputRef}
                        type="file" onChange={uploadFiles}
                        multiple="multiple" />
                    Agregar imagen/video
                </Button>
            </Stack>

            {/* <Box sx={{ mt: 3 }}>
                <Typography variant='body1'>Preview en HTML</Typography>
                <textarea defaultValue={text} rows={5} style={{ width: '100%' }} disabled></textarea>
            </Box> */}

            <DragDropRow
                setOpen={setOpen}
                row={row}
                setRow={setRow}
            />

            <Button variant='contained'
                onClick={addRow}>
                Agregar fila
            </Button>

            <QuillEditDialog
                open={open}
                setOpen={setOpen}
                row={row} setRow={setRow}
                
            />

            <BlockDialog
                open={open1}
                setOpen={setOpen1}
                rowLength={row.length}
                insertBlock={insertBlock}
            />

            <Fab color="primary"
                aria-label="add" sx={{
                    position: "fixed",
                    bottom: (theme) => theme.spacing(2),
                    right: (theme) => theme.spacing(2)
                }}
                disabled={loading2}
                onClick={saveBlog}>
                <SaveIcon />
            </Fab>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading2}>
                <CircularProgress />
            </Backdrop>
        </Container>
    );
};

export default AddBlog;